function notif( notif_type, text){
    if(!text){
        return false
    }
    let id = Math.random().toString(36).substring(7);

    $('#notif_wrapper').append('<div id="'+ id +'" class="notif hide '+ notif_type +'">'+ text +'</div>');

    $('#'+id).fadeIn('fast');

    if( $('.notif').length > 3 ){
        $('.notif').first().remove();
    }

    setTimeout(function(){
        $('#'+id).fadeOut('slow', function(){
            $(this).remove();
        });
    }, 4500);
}

$(document).on('click', '.woocommerce-message.notif', function(){
    $(this).fadeOut('slow', function(){
        $(this).remove();
    })
})
